{
    "ChangeUserAgent_Title": "Definir perfil de exibição do navegador",
    "ChangeUserAgent_SubTitle": "Selecione o perfil de exibição do navegador no qual você deseja visualizar o conteúdo da página da web durante sua sessão atual neste computador.",
    "ChangeUserAgent_FieldName_BrowserProfile": "Perfil do navegador",
    "ChangeUserAgent_Options_ForceAutomaticBrowserDetection": "[Forçar detecção automática do navegador]",
    "ChangeUserAgent_FooterActions_Apply": "Aplicar",
    "ChangeUserAgent_FooterActions_Cancel": "Cancelar",
    "NAME": "ChangeUserAgentLanguage"
}